module.exports = "/static/Images/pt-br/survey_yes.png";